import { isCNHost } from "./isCNHost";

const linkConfig = {
    CN: {
        quote: "https://developers.fuxinsoft.cn",
        freeTrial: "https://developers.fuxinsoft.cn/free-trial",
        edit_pdfs: "https://devdocs.fuxinsoft.cn/development-guide/pdf-sdk-web/features/the-edit-modules.html",
    },
    international: {
        quote: "https://developers.foxit.com/contact/?utm_source=webviewerdemo&utm_medium=referral&utm_campaign=clickquote",
        freeTrial: "https://developers.foxit.com/pdf-sdk/free-trial/?utm_source=webviewerdemo&utm_medium=referral&utm_campaign=clickfreetrial",
        edit_pdfs: "https://developers.foxit.com/developer-hub/document/pdf-sdk-web-edit-pdfs/?utm_source=webviewerdemo&utm_medium=referral&utm_campaign=editpdfsarticle",
    }
}

export const getLink = (keyword) => {
  return linkConfig[isCNHost ? 'CN' : 'international'][keyword];
};
